module.exports = __webpack_public_path__ + "img/spiner-loader.d14e6a04.png";